import { render, staticRenderFns } from "./PartnersView.vue?vue&type=template&id=817ebf6a&scoped=true"
import script from "./PartnersView.vue?vue&type=script&lang=js"
export * from "./PartnersView.vue?vue&type=script&lang=js"
import style0 from "./PartnersView.vue?vue&type=style&index=0&id=817ebf6a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "817ebf6a",
  null
  
)

export default component.exports